import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'

export type StepSelection = number | number[] | number[][] | Record<string, unknown> | null

export type StepSelectionData = {
  selection?: StepSelection
  filters?: Record<string, number>
}

const validateStepSelectionDataRecord = createValidate<Record<string, StepSelectionData>>()

export const parseStepSelectionDataRecord = (data: unknown) => {
  validateGuard(validateStepSelectionDataRecord, data, 'StepSelectionDataRecord')
  return data
}
